import type React from "react";
import { isIOS } from "@/lib/utils/ua";

export const PREVIEW_FRAME_CLASS = "mx-auto aspect-video w-full max-w-[min(640px,80vh)]";

export const VIDEO_STYLE: React.CSSProperties = {
  objectFit: "contain",
  ...(isIOS() ? { transform: "translateZ(0)", WebkitTransform: "translateZ(0)" } : {}),
};
